// Mapping of simple icon names to full Font Awesome class strings
// Supports Font Awesome Pro duo-tone icons (fad) and regular icons
export const iconMap: Record<string, string> = {
  envelope: "fad fa-envelope",
  github: "fab fa-github",
  google: "fab fa-google",
  save: "fad fa-save",
  edit: "fad fa-edit",
  "external-link-alt": "fad fa-external-link-alt",
  download: "fad fa-download",
  trash: "fad fa-trash",
  "chevron-down": "fas fa-chevron-down",
  copy: "fad fa-copy",
  check: "fad fa-check",
  bars: "fas fa-bars",
  camera: "fad fa-camera",
  plus: "fad fa-plus",
  upload: "fad fa-upload",
  "cloud-upload": "fad fa-cloud-upload-alt",
  "file-upload": "fad fa-file-upload",
  create: "fas fa-plus",
  add: "fad fa-plus",
  submit: "fad fa-paper-plane",
  delete: "fad fa-trash",
  cancel: "fad fa-times",
  close: "fad fa-times",
  "arrow-left": "fad fa-arrow-left",
  "arrow-right": "fad fa-arrow-right",
  search: "fad fa-search",
  filter: "fad fa-filter",
  settings: "fad fa-cog",
  key: "fad fa-key",
  "key-skeleton": "fad fa-key-skeleton",
  video: "fad fa-video",
  file: "fad fa-file",
  "file-alt": "fad fa-file-alt",
  label: "fad fa-tag",
  labels: "fad fa-tags",
  change: "fad fa-exchange-alt",
  update: "fad fa-sync-alt",
  refresh: "fad fa-sync-alt",
  play: "fad fa-play",
  pause: "fad fa-pause",
  stop: "fad fa-stop",
  "credit-card": "fad fa-credit-card",
  "dollar-sign": "fad fa-dollar-sign",
  invoice: "fad fa-file-invoice",
  subscription: "fad fa-calendar-check",
  contact: "fad fa-envelope",
  "user-plus": "fad fa-user-plus",
  "user-edit": "fad fa-user-edit",
  users: "fad fa-users",
  "user-cog": "fad fa-user-cog",
  lock: "fad fa-lock",
  "lock-open": "fad fa-lock-open",
  eye: "fad fa-eye",
  "eye-slash": "fad fa-eye-slash",
  image: "fad fa-image",
  "image-polaroid": "fad fa-image-polaroid",
  clear: "fad fa-eraser",
  remove: "fad fa-minus-circle",
  confirm: "fad fa-check-circle",
  destroy: "fad fa-trash-alt",
  "sign-out": "fad fa-sign-out-alt",
  "sign-in": "fad fa-sign-in-alt",
  cube: "fad fa-cube",
  user: "fad fa-user",
  "file-invoice-dollar": "fad fa-file-invoice-dollar",
}









